import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { inject } from '@angular/core';
import { TrackingService } from '../service/tracking/tracking-service';

export function trackVirtualPageView(_: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
  const trackingService = inject(TrackingService);
  trackingService.trackVirtualPageView(state.url);
  return true;
}

export const trackingGuard: CanActivateFn = trackVirtualPageView;
